/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { LANGUAGE, CHAT_APP } from "../../constants/constant";
import "../../chatApp.css";
import {
  addQueryData,
  getCategories,
  getCountries,
  getTypeOfCategories,
} from "../../redux/slices/FormSlice/formSlice";
import { getQueryFormSchema } from "../../schemas";
import { getLanguage } from "../../util/UtilMethods";
import FormInput from "../common/FormInput";
import StandardDropDown from "./StandardDropDown";

const ChatFormBody = () => {
  const [categories, setCategories] = useState([]);
  const [typeOfQueryueries, setTypeOfQueryueries] = useState({});
  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState("");
  const dispatch = useDispatch();

  const { categoriesList, countriesList, typeOfCategoriesList } = useSelector(
    (state) => state.form
  );

  //intial value for form fields
  const initialValues = {
    fullName: "",
    email: "",
    contact: "",
    category: "",
    countryCode: "971",
    query: "",
    description: "",
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: getQueryFormSchema(t),

      onSubmit: (action) => {
        handleQueryData();
        action.resetForm({ values: initialValues });
      },
    });

  useEffect(() => {
    dispatch(getCategories());
    dispatch(getCountries());
  }, []);

  // useEffect called when category is changed
  useEffect(() => {
    if (values.category !== "") {
      const requestBody = {
        categoryType: values.category,
        language:
          LANGUAGE.ENGLISH === getLanguage() ? LANGUAGE.EN_US : LANGUAGE.AR_SA,
      };
      dispatch(getTypeOfCategories(requestBody));
    }
  }, [values.category]);

  // useEffect called when categoriesList is changed
  useEffect(() => {
    if (categoriesList?.length > 0) {
      categoriesList?.forEach((list) => {
        if (CHAT_APP.CATEGORY === list.name) {
          setCategories(list.listTypeEntries);
        }
      });
    }
  }, [categoriesList]);

  // useEffect called when typeOfCategoriesList is changed
  useEffect(() => {
    if (typeOfCategoriesList) {
      setTypeOfQueryueries(typeOfCategoriesList);
    }
  }, [typeOfCategoriesList]);

  // useEffect called when countriesList is changed
  useEffect(() => {
    if (countriesList?.length > 0) {
      setCountries(countriesList);
      const country = countriesList.find((country) => country.value === 971);
      values.countryCode = country ? country.value : undefined;
    }
  }, [countriesList]);

  const handleQueryData = async () => {
    const queryData = {
      fullName: values?.fullName,
      emailAddress: values?.email,
      queryDiscription: values?.description,
      contactNo: values?.contact,
      contryCode: countryCode,
      category: values?.category,
      typeOfQuery: values?.query,
    };
    dispatch(addQueryData(queryData));
  };

  const handleCountryChange = (e) => {
    const selectedCountryCode = e.value;
    setCountryCode(selectedCountryCode);
  };

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="form-group ">
        <div className="d-flex">
          <label className="form-text" htmlFor="fullName">
            {t("full_name")}
          </label>
          <span className="asterisk">*</span>
        </div>
        <FormInput
          type="text"
          placeholder={t("full_name")}
          className="form-control"
          id="fullName"
          name="fullName"
          maxLength="50"
          defaultValue={values.fullName || ""}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {errors.fullName && touched.fullName ? (
          <p className="form-error">{errors.fullName}</p>
        ) : null}
      </div>

      <div className="form-group">
        <div className="d-flex">
          <label className="form-text" htmlFor="emailAddress">
            {t("email_address")}
          </label>
          <span className="asterisk">*</span>
        </div>
        <FormInput
          type="text"
          className="form-control"
          id="emailAddress"
          placeholder={t("email_address")}
          maxLength="50"
          name="email"
          defaultValue={values.email || ""}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {errors.email && touched.email ? (
          <p className="form-error">{errors.email}</p>
        ) : null}
      </div>

      <div
        className={`contact-container ${
          LANGUAGE.ENGLISH === getLanguage() ? "ltr" : "rtl"
        }`}
      >
        <div className="d-flex">
          <label className="form-text" htmlFor="contactNumber">
            {t("contact_no")}
          </label>
          <span className="asterisk">*</span>
        </div>

        <div className="input-group mb-3 x" style={{ direction: "ltr" }}>
          <div className="input-group-prepend">
            <StandardDropDown
              placeHolder="countryCode"
              options={countriesList}
              onChange={handleCountryChange}
              name="countryCode"
              className={
                "form-select select-box contact-select primary-navy-blue common-select"
              }
              defaultValue="971"
            />
          </div>
          <FormInput
            type="tel"
            name="contact"
            className="form-control group-text country-code-input"
            maxLength="16"
            value={`+${countryCode}`}
            onChange={handleChange}
            readOnly={true}
          />
          <FormInput
            type="tel"
            name="contact"
            className="form-control group-text contact-input pl-0"
            id="contactNumber"
            maxLength="16"
            placeholder="000 000 000"
            defaultValue={values.contact}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
        {errors.contact && touched.contact ? (
          <p className="form-error">{errors.contact}</p>
        ) : null}
      </div>

      <div className="form-group ">
        <div className="d-flex">
          <label className="form-text" htmlFor="category">
            {t("category")}
          </label>
          <span className="asterisk">*</span>
        </div>
        <select
          name="category"
          className="form-select select-box"
          id="category"
          defaultValue={values.category}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option hidden>{t("select")}</option>
          {categories?.length > 0 &&
            categories?.map((category, index) => (
              <option value={category.key} key={index}>
                {LANGUAGE.ENGLISH === getLanguage()
                  ? category.name_i18n["en-US"]
                  : category.name_i18n["ar-SA"]}
              </option>
            ))}
        </select>
        {errors.category && touched.category ? (
          <p className="form-error">{errors.category}</p>
        ) : null}
      </div>

      <div className="form-group ">
        <div className="d-flex">
          <label className="form-text" htmlFor="typeOfQuery">
            {t("type_of_query")}
          </label>
          <span className="asterisk">*</span>
        </div>
        <select
          name="query"
          className="form-select select-box"
          id="typeOfQuery"
          defaultValue={values.query}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option hidden>{t("select")}</option>
          {Object.keys(typeOfQueryueries)?.length > 0 &&
            Object.keys(typeOfQueryueries)?.map((query, index) => (
              <option value={query} key={index}>
                {typeOfQueryueries[query]}
              </option>
            ))}
        </select>

        {errors.query && touched.query ? (
          <p className="form-error">{errors.query}</p>
        ) : null}
      </div>

      <div className="form-group ">
        <div className="d-flex">
          <label className="form-text" htmlFor="queryDescription">
            {t("query_description")}
          </label>
          <span className="asterisk">*</span>
        </div>
        <textarea
          name="description"
          placeholder={t("query_description")}
          rows="3"
          type="text"
          className="form-control"
          id="queryDescription"
          defaultValue={values.description}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {errors.description && touched.description ? (
          <p className="form-error">{errors.description}</p>
        ) : null}
      </div>
      <button>{t("start_chat")}</button>
    </form>
  );
};

export default ChatFormBody;
